module.exports = "https://cdn.qantashotels.com/jetstarholidaysui/_next/static/images/map-d2e3dd05a80e3a16aeec8c895b08fa1d.png";